/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CcsBaseResponse } from '../models/CcsBaseResponse';
import type { GetCcsAgreeYnResponse } from '../models/GetCcsAgreeYnResponse';
import type { GetSafetyDrivingHabitResponse } from '../models/GetSafetyDrivingHabitResponse';
import type { GetUbiAgreeInfoQuery } from '../models/GetUbiAgreeInfoQuery';
import type { GetUbiAgreeInfoResponse } from '../models/GetUbiAgreeInfoResponse';
import type { GetUbiAgreeYnQuery } from '../models/GetUbiAgreeYnQuery';
import type { UpdateUbiAgreeInfoCommand } from '../models/UpdateUbiAgreeInfoCommand';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class UbiCcsControllerService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * [CCS only] UBI 고객 동의 갱신
   * UBI 고객 동의 정보를 갱신합니다(동의/철회)
   * @returns CcsBaseResponse OK
   * @throws ApiError
   */
  public updateUbiAgreeInfo({
    vin,
    requestBody,
  }: {
    vin: string,
    requestBody: UpdateUbiAgreeInfoCommand,
  }): CancelablePromise<CcsBaseResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/ccs/ubiagreenres/',
      headers: {
        'vin': vin,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * [CCS only] UBI 고객 동의 갱신
   * UBI 고객 동의 정보를 갱신합니다(동의/철회)
   * @returns CcsBaseResponse OK
   * @throws ApiError
   */
  public updateUbiAgreeInfo1({
    vin,
    requestBody,
  }: {
    vin: string,
    requestBody: UpdateUbiAgreeInfoCommand,
  }): CancelablePromise<CcsBaseResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/ccs/ubiagreenres',
      headers: {
        'vin': vin,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * [CCS only] UBI 고객 동의 내역 조회
   * UBI 고객 동의 내역을 조회합니다
   * @returns GetUbiAgreeInfoResponse OK
   * @throws ApiError
   */
  public getUbiAgreeInfo({
    vin,
    master,
    requestBody,
  }: {
    vin: string,
    master: boolean,
    requestBody: GetUbiAgreeInfoQuery,
  }): CancelablePromise<GetUbiAgreeInfoResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/ccs/ubiagreenreq',
      headers: {
        'vin': vin,
        'master': master,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * [CCS only] UBI 고객 동의 내역 조회
   * UBI 고객 동의 내역을 조회합니다
   * @returns GetUbiAgreeInfoResponse OK
   * @throws ApiError
   */
  public getUbiAgreeInfo1({
    vin,
    master,
    requestBody,
  }: {
    vin: string,
    master: boolean,
    requestBody: GetUbiAgreeInfoQuery,
  }): CancelablePromise<GetUbiAgreeInfoResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/ccs/ubiagreenreq/',
      headers: {
        'vin': vin,
        'master': master,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * [CCS only] 안전 운전 습관 조회
   * 안전 운전 습관 정보를 조회합니다
   * @returns GetSafetyDrivingHabitResponse OK
   * @throws ApiError
   */
  public getSafetyDrivingHabit({
    vin,
  }: {
    vin: string,
  }): CancelablePromise<GetSafetyDrivingHabitResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/ccs/safetydrivinghabit',
      headers: {
        'vin': vin,
      },
    });
  }
  /**
   * [CCS only] 안전 운전 습관 조회
   * 안전 운전 습관 정보를 조회합니다
   * @returns GetSafetyDrivingHabitResponse OK
   * @throws ApiError
   */
  public getSafetyDrivingHabit1({
    vin,
  }: {
    vin: string,
  }): CancelablePromise<GetSafetyDrivingHabitResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/ccs/safetydrivinghabit/',
      headers: {
        'vin': vin,
      },
    });
  }
  /**
   * [CCS only] CCS 동의 여부 조회
   * CCS 동의 여부를 조회합니다
   * @returns GetCcsAgreeYnResponse OK
   * @throws ApiError
   */
  public getCcsAgreeYn({
    vin,
    requestBody,
  }: {
    vin: string,
    requestBody: GetUbiAgreeYnQuery,
  }): CancelablePromise<GetCcsAgreeYnResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/ccs/ccsagreeyn',
      headers: {
        'vin': vin,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * [CCS only] CCS 동의 여부 조회
   * CCS 동의 여부를 조회합니다
   * @returns GetCcsAgreeYnResponse OK
   * @throws ApiError
   */
  public getCcsAgreeYn1({
    vin,
    requestBody,
  }: {
    vin: string,
    requestBody: GetUbiAgreeYnQuery,
  }): CancelablePromise<GetCcsAgreeYnResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/ccs/ccsagreeyn/',
      headers: {
        'vin': vin,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
}
